module.exports = __webpack_public_path__ + "media/images/img_icon_02-f5c6f9df356301265ccaf2ac6979799b.png";